import KeyFeaturesComponent from "@/components/keyFeatures";
import { kubernetesKeyFeatures } from "./constants";

const KubernetesBenefits = () => {
  return <KeyFeaturesComponent {...kubernetesKeyFeatures} />;
};

export default KubernetesBenefits;
